@if (consultant$ | async; as consultant) {
  <div class="consultant">
    <div class="d-flex">
      <div class="hidden-xs mrl">
        <div
          class="img-wrap"
          [ngStyle]="{
            'background-image':
              'url(' +
              (consultant.pictureFile ||
                'assets/img/consultants/Consultant-defaut-PP-blue.png') +
              ')',
          }"
        ></div>
      </div>
      @if (!customLabel && productLabel === 'fiscality_rent') {
        <div class="pvm">
          <div class="text-bold text-primary">
            Vous souhaitez optimiser la fiscalité de vos location meublée ?
          </div>
          <div>
            Prenez rendez-vous avec votre conseiller {{ consultant.firstName }}
            {{ consultant.lastName }}
          </div>
        </div>
      }
      @if (!customLabel && productLabel !== 'fiscality_rent') {
        <div class="pvm">
          <div class="text-bold text-primary">
            Vous souhaitez investir
            @if (productLabel) {
              <span> en {{ productLabel }}</span>
            }
            ?
          </div>
          <div>Prenez rendez-vous, votre conseiller vous recontactera !</div>
        </div>
      }
      @if (customLabel) {
        <div class="pvm">
          <div class="text-bold text-primary">{{ productLabel }}</div>
          @if (productLabelInfo) {
            <div>{{ productLabelInfo }}</div>
          }
          @if (!productLabelInfo) {
            <div>Prenez rendez-vous, votre conseiller vous recontactera !</div>
          }
        </div>
      }
    </div>
    <div class="text-center">
      <button
        class="pr-btn pulse-button"
        title-action
        (click)="showModal($event, template)"
        [eaAnalyticEvent]="[productLabel, 'footer', 'prendre rdv']"
      >
        Prendre rendez-vous
      </button>
    </div>
  </div>
  <!-- modal -->
  <ng-template #template>
    <div class="modal-header text-center">
      <img
        src="assets/img/sheets/contact-pop.png"
        width="138"
        alt="PRENDRE RENDEZ-VOUS"
        [eaAnalyticEvent]="['cta', 'footer', 'prendre rdv']"
      />
      <button
        type="button"
        class="close pull-right"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body text-center">
      @if (submitting) {
        <i class="fa fa-spinner fa-spin text-primary"></i>
      }
      @if (!submitting) {
        @if (hasPhone) {
          <p class="text-primary text-title">
            Votre conseiller {{ consultant.firstName }}
            {{ consultant.lastName }} est prévenu 📩
          </p>
          <p class="text-gray text-subtitle">
            Votre conseiller étudie votre demande et vous rappelle dans les plus
            brefs délais
          </p>
          <div class="btn-modal-contact">
            <button
              type="button"
              class="btn btn-success"
              (click)="modalRef.hide()"
            >
              Fermer
            </button>
          </div>
        }
        @if (!hasPhone) {
          <p class="text-title text-primary">
            Entrez votre numéro afin que votre conseiller puisse vous rappeler
            ☎
          </p>
          <form
            [formGroup]="numberForm"
            (ngSubmit)="onNumberForm(numberForm)"
            novalidate
          >
            <input type="text" formControlName="phone" placeholder="06..." />
            <div class="btn-modal-contact">
              <button type="submit" class="btn btn-success">Envoyer</button>
            </div>
          </form>
        }
      }
    </div>
  </ng-template>
}
